import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { Popup } from '@store/models';

@Component({
    selector: 'app-popups-ui',
    templateUrl: './popups.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PopupsComponent {

    @Input() popups: Popup[];
    @Output() updateSeen = new EventEmitter<Popup>();
    @Output() dismiss = new EventEmitter();

    onUpdateSeen(event, popup: Popup) {
        event.stopPropagation();
        this.updateSeen.emit(popup);
    }

    onDismiss() {
        this.dismiss.emit();
    }

}
